import { supabase } from '../config/supabase';
import {
  CanonicalEventName,
  isActivatedUser,
  isSafeEventProperties,
} from '../utils/activation';
import { eventInsertPayload } from '../utils/eventOwnership';

export async function recordProductEvent(
  eventName: CanonicalEventName,
  properties: Record<string, unknown> = {}
): Promise<void> {
  if (!isSafeEventProperties(properties)) {
    return;
  }

  const { data: sessionData } = await supabase.auth.getSession();
  const userId = sessionData.session?.user?.id;
  if (!userId) return;

  const owned = eventInsertPayload(userId, eventName);
  if (!owned) return;

  const { error } = await supabase.from('product_events').insert({
    user_id: owned.user_id,
    event_name: owned.event_name,
    source: 'client',
    properties,
  });

  if (error && !`${error.message}`.includes('duplicate') && error.code !== '23505') {
    console.warn('product event not recorded:', eventName);
  }
}

export async function recordActivationIfEligible(snapshot: {
  hasCompletedOnboarding?: boolean;
  golfBag?: unknown;
  clubDistances?: unknown;
}): Promise<void> {
  if (!isActivatedUser(snapshot)) return;
  await recordProductEvent('USER_ACTIVATED');
}
